import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import cookies from 'js-cookie';
import TableTemplateEditor from './TableTemplateEditor';
import TableDisplayEditor from './TableDisplayEditor';
import PosTemplateEditor from './PosTemplateEditor';

function TableRenderPage() {
  const reduxTemplateData = useSelector((state) => state?.currentTemplate?.templateContent);
  const localTemplateData = JSON.parse(sessionStorage.getItem('templateEditData'));

  const [templateData, setTemplateData] = useState(reduxTemplateData || localTemplateData || null);
  const [isFromParent, setIsFromParent] = useState(true);

  const STORAGE_KEYS = {
    TEMPLATE: 'templateEditData',
    CURRENT: 'currentTemplate',
    FROM_PARENT: 'isFromParent',
  };

  const PARENT_ORIGIN = process.env.REACT_APP_PARENT_ORIGIN; // from .env

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== PARENT_ORIGIN) return;

      const {
        templateDatas, isParent, accessToken, refreshToken,
      } = event.data || {};
      if (!templateDatas) return;

      setTemplateData(templateDatas);
      setIsFromParent(isParent || false);

      // Store template in sessionStorage
      sessionStorage.setItem(STORAGE_KEYS.TEMPLATE, JSON.stringify(templateDatas));
      sessionStorage.setItem(STORAGE_KEYS.CURRENT, JSON.stringify(templateDatas));
      sessionStorage.setItem(STORAGE_KEYS.FROM_PARENT, true);

      // Set cookies
      cookies.set('secure-auth-access', accessToken, { path: '/' });
      cookies.set('secure-auth-refresh', refreshToken, { path: '/' });
    };

    window.addEventListener('message', handleMessage);

    // Notify parent that child is ready
    window.opener?.postMessage({ ready: true }, PARENT_ORIGIN);

    return () => window.removeEventListener('message', handleMessage);
  }, []);

  useEffect(() => {
    if (templateData) {
      sessionStorage.setItem('templateEditData', JSON.stringify(templateData));
      sessionStorage.setItem('currentTemplate', JSON.stringify(templateData));
    }
  }, [templateData]);

  useEffect(() => {
    if (reduxTemplateData) {
      setTemplateData(reduxTemplateData); // override old value
      setIsFromParent(false); // internal navigation
      // localStorage.setItem('templateEditData', JSON.stringify(reduxTemplateData));
    }
  }, [reduxTemplateData]);

  // On first render, try loading from localStorage
  useEffect(() => {
    if (!templateData) {
      const saved = JSON.parse(sessionStorage.getItem('templateEditData'));
      if (saved) setTemplateData(saved);
    }
  }, [templateData]);

  if (!templateData) return <div>Loading template...</div>;

  const templateType = templateData?.template_type;
  return (
    <>
      {templateType === 'Menu Board' && (
        <TableTemplateEditor templateData={templateData} isFromParent={isFromParent} />
      )}
      {templateType !== 'Menu Board' && templateType !== 'Integration' && (
        <TableDisplayEditor templateData={templateData} />
      )}
      {templateType === 'Integration' && (
        <PosTemplateEditor templateData={templateData} isFromParent={isFromParent} />
      )}
    </>
  );
}

export default TableRenderPage;
